var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[(_vm.checkPermission)?_c('span',[_vm._v(" "+_vm._s(_vm.item.title)+" ")]):_c('span',[_vm._v(" Non hai accesso a questo contenuto. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }